// extracted by mini-css-extract-plugin
export default {"MainGrid":"PlatesContainer2_MainGrid__7elMS","noItems":"PlatesContainer2_noItems__jHhnu"};